import useParamWorkspaceId from '@/hook/useParamWorkspaceId';
import { useGetHourlyUsageLogs } from '@/service/llm/usage-logs/hook';
import dayjs from 'dayjs';
import CardChartTotal from '@/components/ui/card-wrapper/CardChartTotal';
import BarChartTotal from './BarChartTotal';
import { useGetLLMApiBilling } from '@/service/llm/billing/hook';
import { fCurrency, fCurrencyUSD } from '@/utils/formatNumber';

const OverviewVisualization = () => {
  const { workspaceId } = useParamWorkspaceId();
  const startDate = dayjs().subtract(24, 'hours').startOf('minute').unix();
  const endDate = dayjs().startOf('minute').unix();
  // const startDate = 1701363600;
  // const endDate = 1704041999;
  const { data } = useGetHourlyUsageLogs(
    {
      startDate: startDate,
      endDate: endDate,
      workspaceId: workspaceId,
    },
    {
      staleTime: 1000 * 60 * 5,
    }
  );

  const llmApiBilling = useGetLLMApiBilling(
    {
      billingAt: {
        startDate: dayjs.unix(startDate).toISOString(),
        endDate: dayjs.unix(endDate).toISOString(),
      },
    },
    {
      staleTime: 1000 * 60 * 5,
    }
  );

  const chartData = data?.map((item) => ({
    date: dayjs(item.timestamp_hour).unix(),
    count: item.count,
    total_prompt_usage: item.total_prompt_usage,
    total_completion_usage: item.total_completion_usage,
  }));

  const chartDataCost = llmApiBilling?.data?.map((item) => ({
    date: dayjs(item.billing_at).unix(),
    amount: item.total_charge || 0,
  }));

  return (
    <div className="flex flex-col gap-4">
      <p className="text-xl font-medium">Usage</p>
      <div className="grid grid-cols-1 gap-4">
        <div className="flex flex-col gap-4">
          <div>
            <p className="text-lg">LLM as a service</p>
            <p className="text-xs text-muted-foreground">
              Statistics for past 24 hours
            </p>
          </div>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            <CardChartTotal
              title="Prompt"
              description="Total Prompt Usage"
              total={
                chartData
                  ?.reduce((acc, curr) => acc + curr.total_prompt_usage, 0)
                  .toLocaleString() || 0
              }
            >
              <BarChartTotal
                chartData={chartData || []}
                chartConfig={{
                  total_prompt_usage: {
                    label: 'Propmpt usage',
                    color: 'hsl(var(--chart-3))',
                  },
                }}
                startTime={startDate}
                latestTime={endDate}
              />
            </CardChartTotal>
            <CardChartTotal
              title="Completion"
              description="Total Completion Usage"
              total={
                chartData
                  ?.reduce((acc, curr) => acc + curr.total_completion_usage, 0)
                  .toLocaleString() || 0
              }
            >
              <BarChartTotal
                chartData={chartData || []}
                chartConfig={{
                  total_completion_usage: {
                    label: 'Completion usage',
                    color: 'hsl(var(--chart-3))',
                  },
                }}
                startTime={startDate}
                latestTime={endDate}
              />
            </CardChartTotal>
            <CardChartTotal
              title="Requests"
              description="Total Usage REST Requests"
              total={
                chartData
                  ?.reduce((acc, curr) => acc + curr.count, 0)
                  .toLocaleString() || 0
              }
            >
              <BarChartTotal
                chartData={chartData || []}
                chartConfig={{
                  count: {
                    label: 'Requests',
                    color: 'hsl(var(--chart-3))',
                  },
                }}
                startTime={startDate}
                latestTime={endDate}
              />
            </CardChartTotal>
          </div>
          <div className="grid gap-4">
            <CardChartTotal
              title="Cost"
              description="API usage cost"
              total={fCurrencyUSD(
                chartDataCost?.reduce((acc, curr) => acc + curr.amount, 0) || 0
              )}
            >
              <BarChartTotal
                chartData={chartDataCost || []}
                chartConfig={{
                  amount: {
                    label: 'Cost',
                    color: 'hsl(var(--chart-3))',
                  },
                }}
                startTime={startDate}
                latestTime={endDate}
                isTicksCenter
              />
            </CardChartTotal>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OverviewVisualization;
